<template>
    <PopupRouterViewDetail :label="myProfile == false ? 'User Info Detail' : 'My Profile'" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card :header="myProfile == false ? 'User Info' : 'My Profile'" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-first-name" label-cols-lg="12"  label="First Name" label-for="input-first-name" size="sm" :model.sync="model.firstName" :isRequired="true" :state="validateState('firstName')" :errorMessage="getErrorMessage(errorMessage.firstName, 'firstName')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-last-name" label-cols-lg="12"  label="Last Name" label-for="input-last-name" size="sm" :model.sync="model.lastName"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox v-if="!myProfile" id="fieldset-password" type="password" label-cols-lg="12"  label="Password" label-for="input-password" size="sm" :model.sync="model.password"  @change="changePassword"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-email" label-cols-lg="12"  label="Email" label-for="input-email" size="sm" :model.sync="model.email"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox v-if="myProfile" id="fieldset-password" type="password" label-cols-lg="12"  label="Password" label-for="input-password" size="sm" :model.sync="model.password"  @change="changePassword"  :isUpdatable="true" />
						<app-input-combobox-autocomplete v-if="!myProfile" :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId" :selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors" @change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendor" :isUpdatable="true"/>
						<app-input-textbox v-if="false" id="fieldset-user-level" label-cols-lg="12"  label="User Level" label-for="input-user-level" size="sm" type="number" :model.sync="model.userLevel"  @change="updateData"  :isUpdatable="true" />
						<app-input-combobox-autocomplete v-if="false" :options="approvalGroups" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Group" id="fieldset-approval-group" size="sm" :model.sync="model.approvalGroupId"   :selected="model.approvalGroup != null ? model.approvalGroup.name : ''" @input="getApprovalGroups" @change="updateData"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedApprovalGroup" />
						<app-input-combobox-autocomplete v-if="!myProfile" :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Process Type" id="fieldset-process-type" size="sm" :model.sync="model.processTypeId" :selected="model.processType != null ? model.processType.code : ''" @input="getProcessTypes" @change="updateData" :isSelectMethodExists="true" @onSelectMethod="setSelectedProcessType" :isUpdatable="true"/>
				</b-col>
            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->
		<b-card no-body class="mt-3" v-if="!myProfile">
			<b-tabs card>
				<b-tab title="Job Position" active>
					<b-row>
						<b-col>
							<app-table-input-popup title="Assigned Job Positions" :bordered="true" 
								:items="userJobPositions" 
								:fields="fieldUserJobPositions" 
								:busy="isDataLoading" small responsive
								@deleteButtonMethod="deleteRowDataUserJobPositions"
								@showPopupAddMethod="resetDataUserJobPositions()"
								:showActionButton="true"
								:showEditButton="false"
								:showDeleteButton="true"
								:showAddButton="true"
								:showAddFromClipboardButton="false"
								:showReplaceFromClipboardButton="false"
								:showUploadButton="false"
								:showDownloadButton="false"
								>
								<template v-slot:cell(no)="row">
									{{ (row.index + 1) }}
								</template>
								<template v-slot:table-busys>
									<div class="text-center my-2">
										<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading...</strong>
									</div>
								</template>
								<template v-slot:cell(approvalStructureName)="row">
									{{ row.item.approvalStructureName }}
								</template>

								<template v-slot:form-add-detail>
									<UserJobPositionInput 
										:openPopup="isShowPopupUserJobPositions"
										:modelId="userUserJobPositionId"
										@resetMethod="resetModal"
										@addButtonMethod="addRowDataUserJobPositions"/>
								</template>
							</app-table-input-popup>
						</b-col>
					</b-row>
				</b-tab>
				<b-tab title="Roles">
					<b-row>
						<b-col>
							<app-table-input-popup title="Assigned Roles" :bordered="true" 
								:items="myRoles" 
								:fields="fieldUserInfoRoles" 
								:busy="isDataLoading" small responsive
								@deleteButtonMethod="deleteRowDataUserRoleDetail"
								@showPopupAddMethod="resetDataUserRoleDetail()"
								:showActionButton="true"
								:showEditButton="false"
								:showDeleteButton="true"
								:showAddButton="true"
								:showAddFromClipboardButton="false"
								:showReplaceFromClipboardButton="false"
								:showUploadButton="false"
								:showDownloadButton="false"
								>
								<template v-slot:cell(no)="row">
									{{ (row.index + 1) }}
								</template>
								<template v-slot:table-busys>
									<div class="text-center my-2">
										<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading...</strong>
									</div>
								</template>
								<template v-slot:cell(role)="row">
									{{ row.item.roleName }}
								</template>

								<template v-slot:form-add-detail>
									<UserRoleDetailInput 
										:openPopup="isShowPopupUserRoleDetail"
										:modelId="userRoleDetailId"
										@resetMethod="resetModal"
										@addButtonMethod="addRowDataUserRoleDetail"/>
								</template>
							</app-table-input-popup>
						</b-col>
					</b-row>
				</b-tab>
			</b-tabs>
		</b-card>

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoList from '@/models/UserInfo/UserInfoList';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import UserRole from '@/models/UserRole/UserRole';
import UserRoleList from '@/models/UserRole/UserRoleList';
import UserRoleFilter from '@/filters/UserRole/UserRoleFilter';
import UserRoleDetail from '@/models/UserRole/UserRoleDetail';
import UserRoleDetailFilter from '@/filters/UserRole/UserRoleDetailFilter';
import UserRoleDetailInput from '@/views/UserRole/UserRoleDetailInput';
import Role from '@/models/Role/Role';
import RoleFilter from '@/filters/Role/RoleFilter';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';
import PopupRouterView from '@/components/PopupRouterView';
import UserJobPositionInput from '@/views/UserInfo/UserJobPositionInput'
import JobPosition from '@/models/JobPosition/JobPosition'
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		PopupRouterViewDetail,
		PopupRouterView,
		AppTableInputPopup,
		UserRoleDetailInput,
		UserJobPositionInput,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			firstName: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				firstName: { required : "First Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldUserInfoRoles: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"role": { "class" : "th-role first-child", "label" : "Role", key: 'role', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterUserInfo : null,
			currentUserInfoPage : 1,
			userInfoPageSize: 10,
			sortByUserInfo: '',
			sortDescUserInfo: '',
			approvalGroups: [],
			approvalGroups: [],
			isApprovalGroupComboLoading: false,
			isShowPopupConfirmation : false,
			isShowPopupUserRoleDetail : false,
			isShowPopupUploadUserRoleDetail : false,
			isDataCommited : false,
			mainRecordId : '',
			isApprovalGroupComboLoading: false,
			roles: [],
			isUserRoleComboLoading: false,
			isRoleComboLoading: false,
			userRoleDetails: [],
			userRoleDetailId : '',
			sortByUserRoleDetail: '',
			sortDescUserRoleDetail: '',
			sortingByUserRoleDetail: [],
			isDownloadUserRoleDetail: false,
			isShowUserRoleDetailFilter: false,
			myRoles: [],
			userJobPositions: [],
			fieldUserJobPositions: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"approvalStructureName": { "class" : "th-job-position first-child", "label" : "Job Position", key: 'approvalStructureName', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			isShowPopupUserJobPositions: false,
			userUserJobPositionId: '',
			vendors: [],
			myProfile: false,
			processTypes: [],
		}
	},
	methods : {
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
			}

			this.$forceUpdate();
			this.updateData();
		},
		setSelectedVendor(item) {
			if(item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfo : async function(id) {
			this.isBusy = true;
			UserInfo.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				UserInfo.getRoles(this, this.model.userName).then(result => {
					this.myRoles = result;
					this.isBusy = false;
				})
				.catch(error => {
					this.isBusy = false;
				})
				UserInfo.getJobPositions(this, this.model.userName).then(result => {
					this.userJobPositions = result;
					this.isBusy = false;
				})
				.catch(error => {
					this.isBusy = false;
				})
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadUserInfo = true;
			this.filterUserInfo.id = this.modelId;
			UserInfo.downloadDataDetail(this, this.filterUserInfo).then(result => {
				this.isDownloadUserInfo = false;
			}).catch(error => { this.isDownloadUserInfo = false; })
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.FirstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getApprovalGroups : async function(input) {
			let filter = new ApprovalGroupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalGroup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalGroups = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedApprovalGroup(item) {
			if(item == undefined || item == null) {
				this.model.approvalGroupId = null;
				this.model.approvalGroup = null;
			} else {
				this.model.approvalGroupId = item.id;
				this.model.approvalGroup = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.userInfoInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						UserInfo.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'userinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						UserInfo.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'userinfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		changePassword() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					UserInfo.changePassword(this, model, id)
					.catch((error) => {
						this.getUserInfo(id);
					});
				}
			});
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					UserInfo.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getUserInfo(id);
					});
				}
			});
		},
		onHidden() {
			this.getUserInfos();
		},
		uploadDataUserRoleDetail(modalEvent, newDatas) {
			this.isShowPopupUploadUserRoleDetail = false; 
		},
		addRowDataUserRoleDetail(modalEvent, model) {
			if (model != null) {
				model.userName = this.modelId;
				UserInfo.addRole(this, model)
				.then((result) => {
					this.getUserInfo(this.modelId);
					this.isShowPopupUserRoleDetail = false;
				});
			}
		},
		async deleteRowDataUserRoleDetail(id) {
			UserRoleDetail.deleteData(this, id).then(result => { this.getUserInfo(this.modelId); });
		},
		async resetDataUserRoleDetail() {
			this.userRoleDetailId = "";
			this.isShowPopupUserRoleDetail = true;
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
			this.isShowPopupUserJobPositions = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		addRowDataUserJobPositions(modalEvent, model) {
			if (model != null) {
				model.userInfoUserName = this.modelId;
				UserInfo.addJobPosition(this, model)
				.then((result) => {
					this.getUserInfo(this.modelId);
					this.isShowPopupUserJobPositions = false;
				});
			}
		},
		deleteRowDataUserJobPositions(id) {
			JobPosition.deleteData(this, id).then(result => { this.getUserInfo(this.modelId); });
		},
		resetDataUserJobPositions() {
			this.userUserJobPositionId = "";
			this.isShowPopupUserJobPositions = true;
		}
	},
	beforeMount() {
		this.filterUserInfo = new UserInfoFilter();
	},
	async mounted(){

		if(this.$route.name === 'myprofile') {
			const myProfile = await this.$http.get(process.env.VUE_APP_API_URL + `UserInfo/Me`);
			console.log("myprofile", myProfile.data);
			this.modelId = myProfile.data.userName;
			await this.getUserInfo(this.modelId);
			this.myProfile = true;
		} else {
			let id = this.$route.params.id;
			let copyData = this.$route.params.copydata;
			if (id != '' && id != null && id != undefined) {
				if (copyData != null && copyData != undefined) {
					this.getUserInfo(id);
				} else {
					this.modelId = id;
					this.getUserInfo(id);
				}
			}
		}
		
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
